module.exports = [
  require('./healing_spirit'),
  require('./holy_weapon'),
]
